import React from 'react';
import styled from 'styled-components';
import { Badge as AntBadge } from 'antd';

const ExtendedBadge = styled(AntBadge)`
  margin-right: 6px;
`;

export const Badge = (props) => <ExtendedBadge {...props} dot />;
